import React from 'react';
import analyticsIcon from '../../assets/combo-chart.png';
import FeatureDetail from './FeatureDetail';

const BusinessAnalytics = () => {
  const benefits = [
    {
      title: 'Data-Driven Decisions',
      description: 'Make informed decisions based on comprehensive data analysis and visualizations.',
    },
    {
      title: 'Real-Time Insights',
      description: 'Access up-to-the-minute analytics dashboards for immediate business insights.',
    },
    {
      title: 'Predictive Analysis',
      description: 'Forecast future trends and outcomes using advanced predictive algorithms.',
    },
    {
      title: 'Customizable Dashboards',
      description: 'Create personalized dashboards to monitor the metrics most important to your role.',
    },
    {
      title: 'Automated Reporting',
      description: 'Schedule and automate reports to be delivered to stakeholders on a regular basis.',
    },
    {
      title: 'Performance Tracking',
      description: 'Monitor KPIs and business goals with intuitive visual indicators and alerts.',
    },
  ];

  const useCases = [
    {
      title: 'Sales Performance',
      description: 'Track sales metrics, analyze trends, and identify opportunities for growth.',
    },
    {
      title: 'Customer Behavior',
      description: 'Understand customer preferences and behavior patterns to improve engagement.',
    },
    {
      title: 'Financial Analysis',
      description: 'Analyze financial data to optimize budgeting, spending, and revenue strategies.',
    },
    {
      title: 'Operational Efficiency',
      description: 'Identify bottlenecks and inefficiencies in your operational processes.',
    },
  ];

  const technologies = [
    { name: 'Power BI', icon: '📊' },
    { name: 'Machine Learning', icon: '🧠' },
    { name: 'AI Analytics', icon: '🤖' },
    { name: 'Big Data', icon: '📈' },
    { name: 'Data Warehousing', icon: '🗄️' },
  ];

  const screenshots = [
    { 
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      caption: 'Interactive dashboard with key performance indicators'
    },
    { 
      image: 'https://images.unsplash.com/photo-1543286386-2e659306cd6c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      caption: 'Predictive analytics forecasting future trends'
    },
  ];

  return (
    <FeatureDetail
      title="Business Analytics"
      subtitle="Make data-driven decisions with comprehensive reporting and predictive analytics."
      description={
        <div>
          <p>
            Our Business Analytics solution transforms your raw data into actionable insights.
            With powerful visualization tools and advanced analytics capabilities, you can uncover
            hidden patterns, track performance metrics, and make informed business decisions.
          </p>
          <p>
            From executive dashboards to detailed reports, our platform provides the right
            level of information to every stakeholder in your organization, ensuring everyone
            has the insights they need to excel in their role.
          </p>
        </div>
      }
      icon={analyticsIcon}
      benefits={benefits}
      useCases={useCases}
      technologies={technologies}
      mainImage="https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
      screenshots={screenshots}
    />
  );
};

export default BusinessAnalytics;
